import React, { useState } from "react";
import { Image } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import NewForm from "react-bootstrap/Form";
import TopBar from "../../components/TopBar";
import "./index.css";
import {
  Form,
  Input,
  Select,
  Space,
  Tooltip,
  Typography,
  DatePicker,
  TimePicker,
  Switch,
  message,
  Button,
} from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";
import { createSurvey } from "../../api/Schedule/createSurvey";
import { createWellness } from "../../api/Schedule/createWellness";
export default function Index() {
  const [form] = Form.useForm();
  const today = moment();
  const dispatch = useDispatch();
  const [show, setShow] = useState(true);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [collapsed, setCollapsed] = useState(false);

  const onChangeDateStart = (values, dateString) => {
    const formattedDate = moment(dateString, "DD-MM-YYYY hh:mm a").format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    setStartTime(formattedDate);
  };
  const onChangeDateEnd = (values, dateString) => {
    const formattedDate = moment(dateString, "DD-MM-YYYY hh:mm a").format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    setEndTime(formattedDate);
  };
  const onFinish = (values) => {
    let userData = JSON.stringify({
      organisationId: localStorage.getItem("organisationId"),
      title: values.title,
      meetingLink: values.link,
      startTime: startTime,
      endTime: endTime,
      type: "SURVEY",
      eventType: "VIRTUAL",
    });
    dispatch(createWellness(userData)).then((res) => {
      if (res.payload.status === "success") {
        message.success("Survey Created");
        form.resetFields();
      } else {
        message.success("Something went wrong");
      }
    });
  };
  const disabledDate = (current) => {
    return current.isBefore(today, "day");
  };
  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />
      <div className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}>
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"}`}>
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          <div className="survey-form bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl shadow-sm p-[24px] font-poppins" style={{ minHeight: "350px" }}>
            <Form
              form={form}
              name="complex-form"
              layout="vertical"
              onFinish={onFinish}
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
            >
              <Form.Item
                style={{
                  marginBottom: 0,
                }}
              >
                <Form.Item
                  label={<span style={{ fontFamily: "Poppins" }}>Title</span>}
                  name="title"
                  rules={[
                    {
                      required: true,
                      message: "Title is required",
                    },
                  ]}
                  style={{
                    display: "inline-block",
                    width: "calc(50% - 8px)",
                  }}
                >
                  <Input
                    placeholder="Enter Title"
                    className="profile_input"
                    style={{ fontFamily: "Poppins" }}
                  />
                </Form.Item>
                <Form.Item
                  label={<span style={{ fontFamily: "Poppins" }}>Link</span>}
                  name="link"
                  rules={[
                    {
                      required: true,
                      message: "Link is required",
                    },
                  ]}
                  style={{
                    display: "inline-block",
                    width: "calc(50% - 8px)",
                    margin: "0 8px",
                  }}
                >
                  <Input
                    placeholder="Add URL of the survey form"
                    className="profile_input"
                    style={{ fontFamily: "Poppins" }}
                  />
                </Form.Item>
              </Form.Item>
              <Form.Item
                style={{
                  marginBottom: 0,
                }}
              >
                <Form.Item
                  label={
                    <span style={{ fontFamily: "Poppins" }}>
                      Go Live Date & Time
                    </span>
                  }
                  name="live_date"
                  rules={[
                    {
                      required: true,
                      message: "Live Date is required",
                    },
                  ]}
                  style={{
                    display: "inline-block",
                    width: "calc(50% - 8px)",
                  }}
                >
                  <DatePicker
                    showTime={{ use12Hours: true }}
                    onChange={onChangeDateStart}
                    style={{ width: "100%", fontFamily: "Poppins" }}
                    disabledDate={disabledDate}
                    className="profile_input"
                    format={"DD-MM-YYYY HH:mm"}
                  />
                </Form.Item>
                <Form.Item
                  label={
                    <span style={{ fontFamily: "Poppins" }}>
                      Expiry Date & Time
                    </span>
                  }
                  name="expiry_date"
                  rules={[
                    {
                      required: true,
                      message: "Expiry Date & Time is required",
                    },
                  ]}
                  style={{
                    display: "inline-block",
                    width: "calc(50% - 8px)",
                    margin: "0 8px",
                  }}
                >
                  <DatePicker
                    showTime={{ use12Hours: true }}
                    onChange={onChangeDateEnd}
                    style={{ width: "100%", fontFamily: "Poppins" }}
                    disabledDate={disabledDate}
                    className="profile_input"
                    format={"DD-MM-YYYY HH:mm"}
                  />
                </Form.Item>
              </Form.Item>

              <Form.Item>
                <Button
                  htmlType={"submit"}
                  className="submit-btn btn-gradient border-0 rounded-xl font-poppins font-semibold text-[13px]"
                  style={{ width: "30%", height: "40px" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
